import React from 'react';

import { MemberServicesPhoneLink } from 'screens/Book/components/MemberServicesPhoneLink';

export const AdditionalInfoVirtual = ({ phone }: { phone?: string }): JSX.Element => {
  return (
    <>
      <strong>
        If you would like to book with a specific provider, you can call us at{' '}
        <MemberServicesPhoneLink phone={phone} /> and a Patient Care Navigator will happily assist
        you with scheduling.
      </strong>
      <br />
      For services that require you to be seen in clinic, such as fertility care, the provider you
      meet with virtually may differ from your treating provider.
      <p>
        In order to provide you with the earliest availability for your appointment, the appointment
        times listed include all providers for this location.
      </p>
    </>
  );
};
